import React, { Component } from "react";
import { Input } from "antd";
import { connect } from "dva";
import { parse } from "qs";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";

import styles from "./index.less";

const { Search } = Input;
const { ListTable } = ListPage;

@connect(({ projectMember }) => ({
  ...projectMember
}))
class MemberView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchName: null
    };

    const columns = [
      {
        title: "项目成员",
        dataIndex: "userName"
      }
    ];

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      columns,
      currentProjectId
    };
  }

  componentDidMount() {
    this.getList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.getList(params);
  };

  getList = pageInfo => {
    const { currentProjectId, searchName } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectMember/fetchProjectMemberList",
      payload: {
        projectId: currentProjectId,
        param: searchName,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  handleSearch = val => {
    this.setState(
      {
        searchName: val
      },
      () => {
        this.getList();
      }
    );
  };

  renderHeader = () => {
    return (
      <div className="header">
        <Search
          style={{ width: 300 }}
          placeholder="搜索项目成员名称"
          onSearch={this.handleSearch}
        />
      </div>
    );
  };

  render() {
    const { columns } = this.state;

    const { spinProps, users, pageInfo } = this.props;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.member
    };

    const tableProps = {
      columns,
      rowKey: "userId",
      list: users,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };
    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          {this.renderHeader()}
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default MemberView;
